module.exports = __webpack_public_path__ + "img/services.4322aa16.svg";